export const ROLE_TYPES = {
	sysAdmin: "SYSADMIN",
	agent: "AGENT",
	superUser: "SUSER",
	user: "USER"
};
